import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAirpodLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAirpodLeft"><Path d="M7.5 13.083V20.5H4.5V8.5C4.5 5.73858 6.73858 3.5 9.5 3.5C10.6257 3.5 11.6643 3.87223 12.5 4.5V12.499C11.6642 13.127 10.6259 13.5 9.5 13.5C8.78876 13.5 8.11255 13.3507 7.5 13.083ZM7.5 13.083V11" stroke="currentColor"/><Path d="M15.5 13V20.5H20" stroke="currentColor"/></CentralIconBase>;
});

export default IconAirpodLeft;
